import { render, staticRenderFns } from "./FarmsBrowse.vue?vue&type=template&id=a5f12a6e&scoped=true"
import script from "./FarmsBrowse.vue?vue&type=script&lang=js"
export * from "./FarmsBrowse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f12a6e",
  null
  
)

export default component.exports